import Vue from "vue";

Vue.component("bo-carousel", require("js/frontend/components/bo-carousel.vue").default);
Vue.component("bo-login", require("js/frontend/components/bo-login.vue").default);
Vue.component("bo-announcement-bar", require("@/v2/components/bo-announcement-bar.vue").default);

const app = new Vue({
    el: "#app",
    data() {
        return {
            generalTranslations: window.bo.generalTranslations,
            loginTranslations: window.bo.loginTranslations,
        };
    },
});
